import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { URLSearchParams } from '@angular/http';
import 'rxjs/add/observable/throw';

import { AuthHttpClient } from '../../../../providers/auth-http.service';

import { default as swal } from 'sweetalert2';


export class SharedJobService {

	public baseUrl: string = '/v1/job';
	public sendNotificationSubject = new Subject <any>();

	constructor(private sHttp: AuthHttpClient) { }

	public get(clientId: number, jobId: string, queryParams?: any): Observable<any> {
		let url = this.baseUrl + '/auth/client/' + clientId + '/job/' + jobId;
		return this.sHttp.get(url, queryParams)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getClientJobs(clientId: number, queryParams?: any): Observable<any> {
		let url = this.baseUrl + '/auth/client/' + clientId + '/jobs';
		return this.sHttp.get(url, queryParams)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public setJobDetails(clientId: string, jobId: string, data: any): Observable<any> {
		let url;
		let body;
		let observableBatch = [];

		for (let field in data) {
			if (data.hasOwnProperty(field)) {
				switch (field) {
					case 'description':
						url = this.baseUrl + '/auth/client/' + clientId + '/job/' + jobId + '/' + field;
						body = JSON.stringify({ value: data[field] });
						observableBatch.push(this.sHttp.patch(url, body).map(this.extractData).catch((error) => {return Observable.throw(error); }));
						break;
					case 'what':
						url = this.baseUrl + '/auth/client/' + clientId + '/job/' + jobId + '/' + field;
						body = JSON.stringify({ value: data[field] });
						observableBatch.push(this.sHttp.patch(url, body).map(this.extractData).catch((error) => {return Observable.throw(error); }));
						break;
					default:
						break;
				}
			}
		}

		return Observable.forkJoin(observableBatch);
	}

	private extractData(res: Response) {
		if (res) {
			let resp: any = res;
			if (res.status === 401) {
				window.location.assign(process.env.LANDING_PAGES_URL);
			}
			if (resp._body && resp._body !== '') {
				let body = res.json();
				if (typeof Object.keys(body)[0] !== 'undefined') {
					if (Object.keys(body).length > 1) {
						return body;
					}
					return body[Object.keys(body)[0]];
				}
			}
			return {};
		}
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
		error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg);
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(errMsg);
	}
static ctorParameters() { return [ { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/services/shared-job.service.ts